module.exports = __webpack_public_path__ + "static/media/jll.07569780.png";